(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function loadMasonryScript(callback) {
    if (window.Masonry) { callback(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/masonry/4.2.2/masonry.pkgd.min.js';
    s.integrity = 'sha512-JRlcvSZAXT8+5SQQAvklXGJuxXTouyq8oIMaYERZQasB8SBDHZauwmAOH0AGJe4yIg3Tx4At3LIOuFLdb8T6Q==';
    s.crossOrigin = 'anonymous';
    s.onload = callback;
    document.head.appendChild(s);
  }

  function initGallery(section) {
    var grid = section.querySelector('.js-masonry');
    if (!grid) return;

    /* Read config from data attributes — these never change after render */
    var colsDesktop = parseInt(grid.dataset.masonryCols,       10) || 3;
    var colsMobile  = parseInt(grid.dataset.masonryColsMobile,  10) || 1;
    var gap         = parseInt(grid.dataset.masonryGap,         10) || 16;

    /* Returns correct column count for current viewport */
    function effectiveCols() {
      return window.innerWidth < 768 ? colsMobile : colsDesktop;
    }

    /* Lightweight image-load watcher — no extra library needed */
    function imagesReady(container, callback) {
      var imgs = Array.from(container.querySelectorAll('img'));
      var remaining = imgs.filter(function (img) { return !img.complete; });
      if (remaining.length === 0) { callback(); return; }
      var done = 0;
      remaining.forEach(function (img) {
        function check() { if (++done === remaining.length) callback(); }
        img.addEventListener('load',  check, { once: true });
        img.addEventListener('error', check, { once: true });
      });
    }

    function rebuildMasonry() {
      var activeCols = effectiveCols();
      var gridWidth  = grid.offsetWidth;
      var w          = Math.floor((gridWidth - gap * (activeCols - 1)) / activeCols);

      /* Keep CSS custom properties in sync for the CSS-columns fallback */
      grid.style.setProperty('--ig-cols',        activeCols);
      grid.style.setProperty('--ig-cols-mobile', colsMobile);
      grid.style.setProperty('--ig-gap',         gap + 'px');

      /* Masonry needs explicit pixel widths on every item */
      grid.querySelectorAll('.image-gallery__item').forEach(function (el) {
        el.style.width = w + 'px';
      });

      /* Always destroy before recreating to avoid stale layout */
      if (grid._masonry) {
        grid._masonry.destroy();
        grid._masonry = null;
      }

      grid._masonry = new Masonry(grid, {
        itemSelector:       '.image-gallery__item',
        columnWidth:        w,
        gutter:             gap,
        fitWidth:           false,
        transitionDuration: '0.2s'
      });

      /* Re-layout once all images have finished loading */
      imagesReady(grid, function () {
        if (grid._masonry) grid._masonry.layout();
      });
    }

    /* Initial build */
    rebuildMasonry();

    /* Rebuild on resize, debounced 150ms */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuildMasonry, 150);
    });
  }

  function bootAll() {
    loadMasonryScript(function () {
      document.querySelectorAll('.image-gallery-section').forEach(function (section) {
        initGallery(section);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* Theme editor live-reload support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector('.js-masonry')) {
      loadMasonryScript(function () { initGallery(section); });
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.image-gallery-section');
    if (section) {
      var grid = section.querySelector('.js-masonry');
      if (grid && grid._masonry) grid._masonry.layout();
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
